<template>
  <div class="customer-doc-list-overview">
    <div class="customer-doc-list">
      <div class="doc-list">
        <template v-for="type in showDocumentTypes">
          <div class="evns" v-if="showEvns(type)" :key="type">
            <h3 v-if="customerDocuments.evns">Einzelverbindungsnachweise</h3>
            <CustomerDocumentList class="evns-list" :documents="customerDocuments.evns" prefix="Einzelverbindungsnachweis" v-if="customerDocuments.evns.length">
              <template v-for="slot in possibleChildSlotsFor('Evns')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </CustomerDocumentList>
            <div class="none" v-else><slot name="txtNoEvns">Aktuell keine</slot></div>
          </div>
          <div class="bills" v-if="showBills(type)" :key="type">
            <h3 v-if="customerDocuments.bills">Rechnungen</h3>
            <CustomerDocumentList class="bills-list" :documents="customerDocuments.bills" prefix="Rechnung" v-if="customerDocuments.bills.length">
              <template v-for="slot in possibleChildSlotsFor('Bills')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </CustomerDocumentList>
            <div class="none" v-else><slot name="txtNoBills">Aktuell keine</slot></div>
          </div>
          <div class="dunnings" v-if="showDunnings(type)" :key="type">
            <slot name="txtHeadlineDunning" v-if="customerDocuments.dunnings.length">Zahlungserinnerung</slot>
            <CustomerDocumentList class="dunnings-list" :documents="customerDocuments.dunnings" prefix="Mahnung" v-if="customerDocuments.dunnings.length">
              <template v-for="slot in possibleChildSlotsFor('Dunnings')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </CustomerDocumentList>
            <div class="none" v-else><slot name="txtNoDunnings">Aktuell keine</slot></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import isValid from '@/mixins/isValid'
import { validationMixin } from 'vuelidate'
import CustomerDocumentList from './CustomerDocumentList.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import extraData from '@/mixins/extraData'

const AvailableDocTypes = ['evns', 'bills', 'dunnings']

export default {
  name: 'CustomerDocumentListOverview',
  components: { CustomerDocumentList },
  computed: {
    showDocumentTypes () {
      return this.extraData?.showDocumentTypes || AvailableDocTypes
    }
  },
  data () {
    return {
      filterDays: null,
      filterDocumentType: null,
      customerDocuments: {
        bills: [],
        evns: [],
        dunnings: [],
        contracts: []
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    transaction('consumerDocumentList'),
    slotProxy(),
    extraData()
  ],
  methods: {
    showEvns (type) {
      return false
    },
    showBills (type) {
      return false
    },
    showDunnings (type) {
      return type === 'dunnings' && this.showDocumentTypes.indexOf('dunnings') !== -1
    },
    getFilter () {
      return {
        days: null,
        documentType: this.filterDocumentType,
        from: null,
        to: null
      }
    }
  },
  apollo: {
    customerDocuments: function () {
      let parts = ''
      this.showDocumentTypes.forEach(value => {
        parts += `${value} { date identifier name url lastAccessDate alreadyAccessed } `
      })
      return wrapQuery(
        gql`query consumerDocumentList ($filter: CustomerDocumentFilterInput!) {
          customerDocuments(customerDocumentFilter: $filter) {
            ${parts}
          }
        }`, this, 'customerDocuments', {
          filter: this.getFilter()
        }
      )
    }
  }
}
</script>
